module.exports = __webpack_public_path__ + "assets/measure_driver_behavior.f081f50b.svg";